
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g_zoYCTxWPIsyKikMLYDea9eYPlYN_45DshkeaseI3FuMIMeta } from "/codebuild/output/src3153879223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index9EXUlNmVHpQBFdtEgtfgPQIGVQ_zwdcQEgZ_45Y6kQTt4Meta } from "/codebuild/output/src3153879223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search6eduKofJuiXReqbT37ikveRqIrOU9gsJO8uF0TVQnx0Meta } from "/codebuild/output/src3153879223/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexDvz8xzHW1NBzRhJVdA5joqLXoLSlgWa_ZRs_PZw0rZgMeta } from "/codebuild/output/src3153879223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93tp4bqZ93Se9WiaNp6UPyVn6B4dl7t6ZL_450Kc8UDO6awMeta } from "/codebuild/output/src3153879223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index7DZT_45acGWAKtkQ2sAxrwPp39j75c4vGK7BroqoKtCgQMeta } from "/codebuild/output/src3153879223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93mwBex7QEbHFcZzxNHlG1yDxdRVuG_45lWDwVaUJ_45l9KoMMeta } from "/codebuild/output/src3153879223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexNlSBS_45bwbEdo7bJ_45HcoxlWpkiCQIsidUfLhjdm0o8q4Meta } from "/codebuild/output/src3153879223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_936hFOlui5rTNaVPFo8ZJ1VZ1SNvuk45LrOWL_yEVgu8UMeta } from "/codebuild/output/src3153879223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexKDLHEpJOEMJfHpwVLlL9J1Qgsu1gCdySCPyBCnfHwxoMeta } from "/codebuild/output/src3153879223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index4sMovStiyozBeSHpk8yhHl9Eoc4vtEiEb8mcSJbYRakMeta } from "/codebuild/output/src3153879223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3153879223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3153879223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3153879223/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3153879223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3153879223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index7DZT_45acGWAKtkQ2sAxrwPp39j75c4vGK7BroqoKtCgQMeta || {},
    component: () => import("/codebuild/output/src3153879223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3153879223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexNlSBS_45bwbEdo7bJ_45HcoxlWpkiCQIsidUfLhjdm0o8q4Meta || {},
    component: () => import("/codebuild/output/src3153879223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3153879223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexKDLHEpJOEMJfHpwVLlL9J1Qgsu1gCdySCPyBCnfHwxoMeta || {},
    component: () => import("/codebuild/output/src3153879223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index4sMovStiyozBeSHpk8yhHl9Eoc4vtEiEb8mcSJbYRakMeta || {},
    component: () => import("/codebuild/output/src3153879223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]